import MarkdownPage from "@/components/MarkdownPage";

export default function About() {
  return (
    <MarkdownPage
      sourcePath="/legal/about-us.md"
      title="About Pathvio — AI Career Planning for India"
      description="Pathvio is an AI-powered career planning platform built specifically for Indian professionals."
    />
  );
}
